<template>
    <transition name="fade">

        <section>
            <div class="modal fade" id="modalBusReg" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{doc.label}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-8">
                                    <div class="form-group">
                                        <label>Place of Registration</label>
                                        <div class="form-row">
                                            <div class="col-sm-6">
                                                <v-select placeholder="- Province -" label="province" class="pb-1" :class="{'vs-invalid': submitting && $v.formLoan.bus_reg_province.$error }" :options="provinces" :reduce="province => province.province_code" v-model="formLoan.bus_reg_province" :clearable="false" @input="getCity(formLoan.bus_reg_province), formLoan.bus_reg_city = null;"></v-select>
                                            </div>
                                            <div class="col-sm-6">
                                                <v-select placeholder="- City -" label="city" :class="{'vs-invalid': submitting && $v.formLoan.bus_reg_city.$error }" :options="cities" :reduce="city => city.city_code" v-model="formLoan.bus_reg_city" :clearable="false"></v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Date of Registration</label>
                                        <date-range-picker v-if="datepicker" ref="reg_date" class="form-control form-control-sm" :class="{'is-invalid': submitting && $v.formLoan.bus_reg_date.$error}" id="bus_reg_date" v-model="formLoan.bus_reg_date" :max-date="maxDate" :min-date="minDate" :start-date="startDate" v-input-mask data-inputmask-alias="datetime" :data-inputmask-max="maxStartDate" :data-inputmask-min="minStartDate" data-inputmask-inputformat="mm/dd/yyyy" placeholder="mm/dd/yyyy"></date-range-picker>
                                    </div>
                                </div>


                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Scanned copy of the Original {{doc.label}}</label>
                                        <div class="input-group">
                                            <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="ref_bus" @change="$emit('attach', $event)">
                                            <input type="text" v-if="fetchATT[code] || formATT[code]" class="form-control form-control-sm ro" @click="browseRef()" readonly :value="doc.details['file']">
                                            <input type="text" v-else class="form-control form-control-sm ro" readonly value="Choose a file.." :class="{'is-invalid': submitting && $v.formATT[code].$error}" @click="browseRef()">
                                            <div class="input-group-append">
                                                <button class="btn btn-sm btn-outline-primary" @click="browseRef()">
                                                    <span v-if="fetchATT[code] || formATT[code] ">Change</span>
                                                    <span v-else>Attach</span>
                                                </button>
                                                <button v-if="fetchATT[code] || formATT[code]" class="btn btn-sm btn-outline-primary ml-2" @click="viewATT(formATT[code], doc.label, fetchATT[code])">View</button>
                                            </div>
                                        </div>

                                        <div class="mt-1">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="progress" v-if="progress[code]">
                                                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress[code]+ ';'">
                                                            {{progress[code]}}
                                                        </div>
                                                    </div>
                                                    <span v-else class="badge" :class="doc.status">{{$parent.attStat(doc.status)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary" data-dismiss="modal" @click="btnCancel">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="btnUpdate">Update</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalBusATT" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{attachFile.title}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="col-12" v-if="attachFile.type=='img'">
                                <img :src="attachFile.url" class="img-fluid" alt="Image">
                            </div>
                            <div class="col-12" v-if="attachFile.type=='pdf'">
                                <object :data="attachFile.url + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="PDF" width="100%" height="100%">
                                    <div class="alert alert-warning2" role="alert">
                                        <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                                    </div>
                                </object>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" @click="closeModalBusATT"><i class="fas fa-times-circle mr-1"></i>Close</button>
                            <button class="btn btn-outline-primary" @click="downloadBusATT(attachFile.url, attachFile.name)"><i class="fas fa-download mr-1"></i>Download</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan', 'docs', 'formATT', 'fetchATT', 'progress', 'attachFile'],
        data() {
            return {
                maxDate: moment().format('MM/DD/YYYY'),
                minDate: moment('01/01/1900', 'MM/DD/YYYY').format('MM/DD/YYYY'),
                startDate: moment().format('MM/DD/YYYY'),
                maxStartDate: moment().format('MM/DD/YYYY'),
                minStartDate: moment('01/01/1900', 'MM/DD/YYYY').format('MM/DD/YYYY'),
                datepicker: false,

                provinces: [],
                cities: [],

                // doc: this.docs.find(item => item.code === 'ATT119'),

                bus_reg_date: null,
                submitting: false,

                code: null,
                doc: []

            }
        },
        validations: {
            formLoan: {
                bus_reg_city: {
                    required
                },
                bus_reg_province: {
                    required
                },
                bus_reg_date: {
                    required
                },
            },
            formATT: {
                ATT119: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT119 && this.code == 'ATT119';
                    })
                },
                ATT120: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT120 && this.code == 'ATT120';
                    })
                },
                ATT121: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT121 && this.code == 'ATT121';
                    })
                }
            }
        },
        created() {},
        methods: {
            btnUpdate: _.debounce(function() {
                this.postBusReg();
            }, 333),
            btnCancel() {
                this.datepicker = false;
                this.submitting = false;
                document.getElementById("bus_reg_date").value = "";
                Fire.$emit('getLoanReq');
                let key = this.code;
                if (this.formATT[key]) {
                    axios.get('/api/v2-get-attach-b2c', {
                            params: {
                                borrower_id: this.formLoan.borrower_id,
                                application_id: this.formLoan.application_id,
                                attachment_code: [key]
                            }
                        })
                        .then(res => {
                            let data = res.data.attach
                            if (data.length) {
                                this.doc.details['file'] = data.attach.slice(9);
                                this.doc.status = 'AS02';
                                this.fetchATT[key] = data.filepath + '/' + data.attach;
                                this.formATT[key] = null;

                            } else {
                                this.doc.details['file'] = null;
                                this.doc.status = 'AS01';
                                this.fetchATT[key] = null;
                                this.formATT[key] = null;
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                }
            },
            convertDate(date, e) {
                let front = 'MM/DD/YYYY';
                let back = 'YYYY-MM-DD';
                if (e == 'server') {
                    return date ? moment(date, front).format(back) : null;
                }
                if (e == 'client') {
                    return date ? moment(date, back).format(front) : null;
                }
            },
            postBusReg() {
                this.submitting = true;
                this.$v.formATT.$touch();
                this.$v.formLoan.$touch();

                this.bus_reg_date = this.convertDate(this.formLoan.bus_reg_date, 'server');
                if (this.$v.formATT.$invalid || this.$v.formLoan.$invalid) {

                } else {
                    let key = this.code;
                    this.$parent.$parent.payloading = true;
                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                        },
                        onUploadProgress: function(progressEvent) {
                            if (this.formATT[key]) {
                                this.progress[key] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                            }
                        }.bind(this)
                    }
                    let formData = new FormData();
                    formData.append('borrower_id', this.formLoan.borrower_id);
                    formData.append('application_id', this.formLoan.application_id);
                    formData.append('upload_file', this.formATT[key]);
                    formData.append('attach_code', key);
                    formData.append('bus_reg_place', this.formLoan.bus_reg_city);
                    formData.append('bus_reg_date', this.bus_reg_date);

                    axios.post('/api/v2-post-bus-reg', formData, config)
                        .then(res => {
                            let data = res.data.attached;
                            if (data) {
                                this.formATT[key] = null;
                                this.progress[key] = 0;
                                this.doc.status = data.status;
                                this.doc.details['file'] = data.attach.slice(9);
                                this.formATT[key] = null;
                                this.fetchATT[key] = data.filepath + data.attach;
                            }
                            window.URL.revokeObjectURL(this.attachFile.url);
                            this.attachFile.url = null;
                            $('#modalBusReg').modal('hide');

                            this.$parent.$parent.payloading = false;
                            Fire.$emit('getLoanReq');
                            Fire.$emit('getAttLoanReq');

                        }).catch(err => {
                            this.$parent.$parent.payloading = false;
                        })
                }
            },
            viewATT(formATT, title, fetchATT) {
                if (formATT) {
                    $('#modalBusReg').modal('hide');
                    this.$parent.viewAttachFile(formATT, title, '#modalBusATT');
                }
                if (fetchATT) {
                    $('#modalBusReg').modal('hide');
                    this.$parent.viewFetch(fetchATT, title, '#modalBusATT', 2)
                }
            },
            closeModalBusATT() {
                window.URL.revokeObjectURL(this.attachFile.url);
                $('#modalBusATT').modal('hide');
                for (let k in this.attachFile) {
                    this.attachFile[k] = null;
                }
                $('#modalBusReg').modal('show');
            },
            downloadBusATT(fileURL, name) {
                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', name.slice(name.length - 22));
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(fileURL);
            },
            browseRef() {
                document.getElementById('ref_bus').click();
            },
            getCity(val) {
                this.$parent.$parent.payloading = true;
                axios.get('/api/v2-ref-city', {
                        params: {
                            province_code: val
                        }
                    })
                    .then(res => {
                        let data = res.data
                        this.cities = data.cities;

                        this.$parent.$parent.payloading = false;
                    })
                    .catch(err => {
                        this.$parent.$parent.payloading = false;
                    })
            },
            getRegionProvince(code) {
                this.$parent.$parent.payloading = true;
                axios.get('/api/v2-ref-region-province')
                    .then(res => {
                        this.$parent.$parent.payloading = false;
                        let data = res.data
                        this.provinces = data.provinces


                        this.doc = this.docs.find(item => item.code === code);
                        this.code = code;

                        this.getCity(this.formLoan.bus_reg_province);

                        this.formLoan.bus_reg_date = this.convertDate(this.formLoan.bus_reg_date, 'client');


                        if (this.formLoan.bus_reg_date) {
                            this.startDate = this.formLoan.bus_reg_date;
                        }

                        this.datepicker = true;
                        this.submitting = false;
                    })
                    .catch(err => {
                        this.$parent.$parent.payloading = false;
                    })
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>